/*
 * Digital Studio Naeema — Premium motion layer v2.
 * Section-level cinematic reveals, card-level reveals, hero parallax,
 * card 3D tilt, a count-up stat for the Interactive Bundle Showcase, and
 * a library-collage open interaction. Fully inert under prefers-reduced-motion.
 */
(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && window.matchMedia('(pointer: fine)').matches;

  function reveal(selector, cls) {
    var nodes = document.querySelectorAll(selector);
    nodes.forEach(function (n) { n.classList.add(cls); });
    if (reduceMotion || !('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('dsn-in'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('dsn-in');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -60px 0px' }
    );
    nodes.forEach(function (n) { io.observe(n); });
  }

  function initReveals() {
    reveal('.dsn-band, .dsn-flagship, .dsn-showcase, .dsn-close, .dsn-season', 'dsn-cinematic');
    reveal(
      '.dsn-cat, .dsn-poster, .cpm-card, .cpt-countdown, .dsn-discovery-head, .dsn-edit-head, .dsn-close-cta, .dsn-lib-card, .dsn-season-float',
      'dsn-reveal'
    );
  }

  function initHeroParallax() {
    var stage = document.getElementById('dsnHeroStage');
    if (!stage) return;
    if (reduceMotion) return;
    if (fine) {
      var raf = null;
      stage.addEventListener('mousemove', function (event) {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          var rect = stage.getBoundingClientRect();
          var x = (event.clientX - rect.left) / rect.width - 0.5;
          var y = (event.clientY - rect.top) / rect.height - 0.5;
          stage.style.setProperty('--mx', (x * 26).toFixed(1) + 'px');
          stage.style.setProperty('--my', (y * 26).toFixed(1) + 'px');
          raf = null;
        });
      });
      stage.addEventListener('mouseleave', function () {
        stage.style.setProperty('--mx', '0px');
        stage.style.setProperty('--my', '0px');
      });
    }
    var scrollRaf = null;
    window.addEventListener(
      'scroll',
      function () {
        if (scrollRaf) return;
        scrollRaf = requestAnimationFrame(function () {
          var rect = stage.getBoundingClientRect();
          var offset = window.innerHeight / 2 - (rect.top + rect.height / 2);
          stage.style.setProperty('--sy', (offset * 0.04).toFixed(1) + 'px');
          scrollRaf = null;
        });
      },
      { passive: true }
    );
  }

  function initCardTilt(selector) {
    if (reduceMotion || !fine) return;
    var cards = document.querySelectorAll(selector);
    cards.forEach(function (card) {
      var raf = null;
      card.addEventListener('mousemove', function (event) {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          var rect = card.getBoundingClientRect();
          var x = (event.clientX - rect.left) / rect.width - 0.5;
          var y = (event.clientY - rect.top) / rect.height - 0.5;
          card.style.transform =
            'perspective(900px) rotateY(' + (x * 6).toFixed(2) + 'deg) rotateX(' + (y * -6).toFixed(2) + 'deg) translateY(-4px)';
          raf = null;
        });
      });
      card.addEventListener('mouseleave', function () {
        card.style.transform = '';
      });
    });
  }

  function initCountUp() {
    var stat = document.querySelector('[data-dsn-countup]');
    if (!stat) return;
    var target = parseInt(stat.getAttribute('data-dsn-countup'), 10) || 0;
    var suffix = stat.getAttribute('data-dsn-suffix') || '';
    if (reduceMotion || !('IntersectionObserver' in window)) {
      stat.textContent = target + suffix;
      return;
    }
    var done = false;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !done) {
          done = true;
          var start = performance.now();
          var duration = 1400;
          function tick(now) {
            var progress = Math.min(1, (now - start) / duration);
            var eased = 1 - Math.pow(1 - progress, 3);
            stat.textContent = Math.round(eased * target) + suffix;
            if (progress < 1) requestAnimationFrame(tick);
          }
          requestAnimationFrame(tick);
          io.unobserve(stat);
        }
      });
    }, { threshold: 0.4 });
    io.observe(stat);
  }

  function initFan() {
    var fan = document.querySelector('.dsn-library');
    if (!fan) return;
    if (fine) {
      fan.addEventListener('mouseenter', function () { fan.classList.add('dsn-library-open'); });
      fan.addEventListener('mouseleave', function () { fan.classList.remove('dsn-library-open'); });
    }
    if (!reduceMotion && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) fan.classList.add('dsn-library-open');
          else if (!fine) fan.classList.remove('dsn-library-open');
        });
      }, { threshold: 0.5 });
      io.observe(fan);
    } else {
      fan.classList.add('dsn-library-open');
    }
  }

  function init() {
    initReveals();
    initHeroParallax();
    initCountUp();
    initFan();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
